// src/blurb-sku/BlurbSkuBase.ts
var BlurbSkuBase = class {
  constructor() {
  }
  isV1() {
    return false;
  }
};
BlurbSkuBase.VERSION = "###";
BlurbSkuBase.SEPARATOR = "-";

// src/blurb-sku/versions/v1/BlurbSkuV1Base.ts
var BlurbSkuV1Base = class extends BlurbSkuBase {
  constructor(data) {
    super();
    this.data = data;
  }
  get version() {
    return this.data.version;
  }
  set version(version) {
    this.data.version = version;
  }
  setVersion(version) {
    this.version = version;
    return this;
  }
  toJSON() {
    return this.data;
  }
  isBook() {
    return false;
  }
  isWallArt() {
    return false;
  }
};
BlurbSkuV1Base.VERSION = "1";
BlurbSkuV1Base.PLACEHOLDER = "*";

// src/blurb-sku/versions/v1/BlurbBookSkuV1.ts
var BlurbBookSkuV1 = class extends BlurbSkuV1Base {
  isV1() {
    return this instanceof BlurbBookSkuV1;
  }
  isBook() {
    return this instanceof BlurbBookSkuV1;
  }
  static parse(sku) {
    const [
      version = BlurbSkuV1Base.VERSION,
      bookFormat = BlurbSkuV1Base.PLACEHOLDER,
      trimSize = BlurbSkuV1Base.PLACEHOLDER,
      coverType = BlurbSkuV1Base.PLACEHOLDER,
      paperType = BlurbSkuV1Base.PLACEHOLDER,
      endsheetType = BlurbSkuV1Base.PLACEHOLDER,
      linenType = BlurbSkuV1Base.PLACEHOLDER
    ] = sku.split(BlurbSkuBase.SEPARATOR);
    return new BlurbBookSkuV1({
      version,
      bookFormat,
      trimSize,
      coverType,
      paperType,
      endsheetType,
      linenType
    });
  }
  static create(data = {}) {
    var _a, _b, _c, _d, _e, _f, _g;
    return new BlurbBookSkuV1({
      version: (_a = data.version) != null ? _a : BlurbSkuV1Base.VERSION,
      bookFormat: (_b = data.bookFormat) != null ? _b : BlurbSkuV1Base.PLACEHOLDER,
      trimSize: (_c = data.trimSize) != null ? _c : BlurbSkuV1Base.PLACEHOLDER,
      coverType: (_d = data.coverType) != null ? _d : BlurbSkuV1Base.PLACEHOLDER,
      paperType: (_e = data.paperType) != null ? _e : BlurbSkuV1Base.PLACEHOLDER,
      endsheetType: (_f = data.endsheetType) != null ? _f : BlurbSkuV1Base.PLACEHOLDER,
      linenType: (_g = data.linenType) != null ? _g : BlurbSkuV1Base.PLACEHOLDER
    });
  }
  get bookFormat() {
    return this.data.bookFormat;
  }
  set bookFormat(bookFormat) {
    this.data.bookFormat = bookFormat;
  }
  setBookFormat(bookFormat) {
    this.bookFormat = bookFormat;
    return this;
  }
  get trimSize() {
    return this.data.trimSize;
  }
  set trimSize(trimSize) {
    this.data.trimSize = trimSize;
  }
  setTrimSize(trimSize) {
    this.trimSize = trimSize;
    return this;
  }
  get coverType() {
    return this.data.coverType;
  }
  set coverType(coverType) {
    this.data.coverType = coverType;
  }
  setCoverType(coverType) {
    this.coverType = coverType;
    return this;
  }
  get paperType() {
    return this.data.paperType;
  }
  set paperType(paperType) {
    this.data.paperType = paperType;
  }
  setPaperType(paperType) {
    this.paperType = paperType;
    return this;
  }
  get endsheetType() {
    return this.data.endsheetType;
  }
  set endsheetType(endsheetType) {
    this.data.endsheetType = endsheetType;
  }
  setEndsheetType(endsheetType) {
    this.endsheetType = endsheetType;
    return this;
  }
  get linenType() {
    return this.data.linenType;
  }
  set linenType(linenType) {
    this.data.linenType = linenType;
  }
  setLinenType(linenType) {
    this.linenType = linenType;
    return this;
  }
  toString() {
    return [
      this.version,
      this.bookFormat,
      this.trimSize,
      this.coverType,
      this.paperType,
      this.endsheetType,
      this.linenType
    ].join(BlurbSkuV1.SEPARATOR);
  }
};
((BlurbBookSkuV12) => {
  let BookFormat;
  ((BookFormat2) => {
    BookFormat2["PhotoBook"] = "PHBK";
    BookFormat2["LayflatPhotoBook"] = "LFBK";
    BookFormat2["TradeBook"] = "TDBK";
    BookFormat2["Magazine"] = "MGZN";
  })(BookFormat = BlurbBookSkuV12.BookFormat || (BlurbBookSkuV12.BookFormat = {}));
})(BlurbBookSkuV1 || (BlurbBookSkuV1 = {}));

// src/blurb-sku/versions/v1/BlurbWallArtSkuV1.ts
var BlurbWallArtSkuV1 = class extends BlurbSkuV1Base {
  isV1() {
    return this instanceof BlurbWallArtSkuV1;
  }
  isWallArt() {
    return this instanceof BlurbWallArtSkuV1;
  }
  static parse(sku) {
    const [
      version = BlurbSkuV1Base.VERSION,
      bookFormat = BlurbSkuV1Base.PLACEHOLDER,
      trimSize = BlurbSkuV1Base.PLACEHOLDER,
      printType = BlurbSkuV1Base.PLACEHOLDER
    ] = sku.split(BlurbSkuBase.SEPARATOR);
    return new BlurbWallArtSkuV1({
      version,
      bookFormat,
      trimSize,
      printType
    });
  }
  static create(data = {}) {
    var _a, _b, _c, _d;
    return new BlurbWallArtSkuV1({
      version: (_a = data.version) != null ? _a : BlurbSkuV1Base.VERSION,
      bookFormat: (_b = data.bookFormat) != null ? _b : BlurbWallArtSkuV1.BookFormat.WallArt,
      trimSize: (_c = data.trimSize) != null ? _c : BlurbSkuV1Base.PLACEHOLDER,
      printType: (_d = data.printType) != null ? _d : BlurbSkuV1Base.PLACEHOLDER
    });
  }
  get bookFormat() {
    return this.data.bookFormat;
  }
  set bookFormat(bookFormat) {
    this.data.bookFormat = bookFormat;
  }
  setBookFormat(bookFormat) {
    this.bookFormat = bookFormat;
    return this;
  }
  get trimSize() {
    return this.data.trimSize;
  }
  set trimSize(trimSize) {
    this.data.trimSize = trimSize;
  }
  setTrimSize(trimSize) {
    this.trimSize = trimSize;
    return this;
  }
  get printType() {
    return this.data.printType;
  }
  set printType(printType) {
    this.data.printType = printType;
  }
  setPrintType(printType) {
    this.printType = printType;
    return this;
  }
  toString() {
    return [this.version, this.bookFormat, this.trimSize, this.printType].join(BlurbSkuV1Base.SEPARATOR);
  }
};
((BlurbWallArtSkuV12) => {
  let BookFormat;
  ((BookFormat2) => {
    BookFormat2["WallArt"] = "WART";
  })(BookFormat = BlurbWallArtSkuV12.BookFormat || (BlurbWallArtSkuV12.BookFormat = {}));
})(BlurbWallArtSkuV1 || (BlurbWallArtSkuV1 = {}));

// src/blurb-sku/versions/v1/BlurbSkuV1.ts
var BlurbSkuV1 = class extends BlurbSkuV1Base {
  isV1() {
    return this instanceof BlurbSkuV1;
  }
  static parse(sku) {
    const [_, bookFormat] = sku.split(BlurbSkuBase.SEPARATOR);
    if (!bookFormat) {
      console.warn('Missing "bookFormat" in provided sku.');
    }
    if (bookFormat && Object.values(BlurbWallArtSkuV1.BookFormat).includes(bookFormat)) {
      return BlurbWallArtSkuV1.parse(sku);
    }
    return BlurbBookSkuV1.parse(sku);
  }
  static create(type) {
    if (type === "WallArt") {
      return BlurbWallArtSkuV1.create();
    }
    return BlurbBookSkuV1.create();
  }
  toString() {
    return `${this.version}`;
  }
};

// src/blurb-sku/index.ts
var VERSIONS = [BlurbSkuV1];
var _BlurbSku = class extends BlurbSkuBase {
  static parse(sku) {
    const [version] = sku.split(BlurbSkuBase.SEPARATOR);
    const VersionClass = VERSIONS.find(({ VERSION }) => VERSION === version);
    if (VersionClass) {
      return VersionClass.parse(sku);
    }
    console.warn(`BlurbSku version "${version}" is not supported.`);
    return new _BlurbSku();
  }
};
var BlurbSku = _BlurbSku;
BlurbSku.createV1 = BlurbSkuV1.create;

// src/core/type/typeGuards.ts
function isUndefined(value) {
  return value === void 0;
}
function isNull(value) {
  return value === null;
}
function isNumber(value) {
  return typeof value === "number" && !Number.isNaN(value);
}
function isString(value) {
  return typeof value === "string";
}
function isObject(value) {
  return typeof value === "object" && !Array.isArray(value) && value !== null;
}
function isFunction(value) {
  return typeof value === "function";
}
function isEmptyString(value) {
  return isString(value) && value.length === 0;
}
function isArray(value) {
  return Array.isArray(value);
}
function isArrayOfType(value, isType) {
  return isArray(value) && value.every((element) => isType(element));
}
function isCustomEvent(value) {
  return value instanceof CustomEvent;
}
function isError(value) {
  return value instanceof Error;
}

// src/core/misc/array.ts
function filterNullableArray(array) {
  return array.filter((value) => !isNull(value) && !isUndefined(value));
}
var sumArray = (...args) => {
  const data = Array.isArray(args[0]) ? args[0] : args;
  return data.reduce((a, b) => (a || 0) + (b || 0), 0);
};
function optArray(condition, array) {
  if (condition)
    return array;
  return [];
}

// src/core/misc/general.ts
function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
function defaultValue(value, def) {
  if (isUndefined(value) || isNull(value))
    return def;
  return value;
}
function safelyParseJson(data) {
  try {
    return JSON.parse(data);
  } catch (_) {
    return null;
  }
}

// src/core/misc/object.ts
function objectsSum(first, second) {
  const output = {};
  for (const key in first) {
    if (Object.prototype.hasOwnProperty.call(first, key) && Object.prototype.hasOwnProperty.call(second, key)) {
      output[key] = first[key] + second[key];
    }
  }
  return output;
}
function optObj(condition, object) {
  if (condition)
    return object;
  return;
}
function groupBy(property, data) {
  return data.reduce((groups, element) => {
    var _a;
    groups[element[property]] = (_a = groups[element[property]]) != null ? _a : [];
    groups[element[property]].push(element);
    return groups;
  }, {});
}
var objectKeys = Object.keys;
var objectEntries = (obj) => Object.entries(obj);

// src/core/api/index.ts
function inlineRetry(callback, options) {
  return async (...args) => {
    let retryCount = 0;
    let retry2 = false;
    do {
      try {
        return await Promise.resolve(callback(...args));
      } catch (error) {
        if (isFunction(options.retry)) {
          retry2 = await options.retry(retryCount, error);
        } else {
          retry2 = retryCount < options.retry - 1;
        }
        if (!retry2)
          throw error;
        if (options.retryDelay)
          await sleep(options.retryDelay);
        retryCount++;
      }
    } while (retry2);
  };
}
async function retry(callback, options) {
  let retryNumber = 1;
  while (retryNumber <= options.maxRetries) {
    try {
      return await callback();
    } catch (error) {
      options.retryCallback(error, options.maxRetries, retryNumber);
      let sleepTime = options.sleepTime;
      if (options.retryBackoff) {
        sleepTime *= Math.pow(options.retryBackoff, retryNumber - 1);
      }
      await sleep(sleepTime);
      retryNumber++;
    }
  }
  throw new Error(`Function "${options.name}" failed after ${options.maxRetries} retries`);
}
var validateObject = (body, validationObject) => {
  for (const key of objectKeys(validationObject)) {
    const validationFn = validationObject[key];
    const validationError = validationFn(body[key]);
    if (validationError) {
      return validationError;
    }
  }
};

// src/core/html/class.ts
function cls(array, ...args) {
  let out = "";
  for (let i = 0; i < array.length; i++) {
    if (Object.prototype.hasOwnProperty.call(args, i)) {
      if (!args[i]) {
        out += array[i].trimEnd();
      } else {
        out += array[i] + args[i];
      }
    } else {
      out += array[i];
    }
  }
  return out;
}
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

// src/core/html/input.ts
function checkNumberInput(onInput) {
  return (event) => {
    const element = event.target;
    if ("max" in element && element.max !== void 0) {
      const max = typeof element.max === "string" ? Number.parseFloat(element.max) : element.max;
      if (element.valueAsNumber > max) {
        event.target.value = String(max);
      }
    }
    if ("min" in element && element.min !== void 0) {
      const min = typeof element.min === "string" ? Number.parseFloat(element.min) : element.min;
      if (element.valueAsNumber < min) {
        event.target.value = String(min);
      }
    }
    return onInput && onInput(event);
  };
}

// src/core/html/link.ts
function MailTo({ email, ...props }) {
  const params = Object.keys(props).map((key) => `${key}=${props[key]}`).join("&");
  return `mailto:${email}${params ? `?${params}` : ""}`;
}

// src/core/testing/index.ts
function randomValue(...values) {
  return values[Math.floor(Math.random() * values.length)];
}
function randomDate(start, end = new Date()) {
  return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
}
function randomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
function delayedResponse(data, delay = 250) {
  return new Promise((resolve) => setTimeout(() => resolve(data), delay));
}
function propertyCombinations(data) {
  return Object.keys(data).reduce((prev, key) => {
    const values = data[key];
    if (values === void 0)
      return prev;
    if (prev.length === 0)
      return values.map((value) => ({ [key]: value }));
    return prev.flatMap((combination) => values.map((value) => ({ ...combination, [key]: value })));
  }, []).flatMap((value) => value);
}

// src/optional/index.ts
var OptionalValue = class {
  constructor(value) {
    this.value = value;
  }
  static isPresent(value) {
    return value !== void 0 && value !== null;
  }
  static empty() {
    return new OptionalValue(null);
  }
  static of(value) {
    if (OptionalValue.isPresent(value)) {
      return new OptionalValue(value);
    }
    return OptionalValue.empty();
  }
  get() {
    return this.value;
  }
  isPresent() {
    return OptionalValue.isPresent(this.value);
  }
  ifPresent(consumer) {
    if (this.isPresent()) {
      consumer(this.value);
    }
    return this;
  }
  isEmpty() {
    return !OptionalValue.isPresent(this.value);
  }
  ifEmpty(consumer) {
    if (this.isEmpty()) {
      consumer();
    }
    return this;
  }
  filter(predicate) {
    if (this.isEmpty()) {
      return this;
    }
    if (predicate(this.value)) {
      return this;
    }
    return OptionalValue.empty();
  }
  map(mapper) {
    if (this.isEmpty()) {
      return this;
    }
    const mapped = mapper(this.value);
    if (OptionalValue.isPresent(mapped)) {
      return OptionalValue.of(mapped);
    }
    return OptionalValue.empty();
  }
  flatMap(mapper) {
    if (this.isEmpty()) {
      return this;
    }
    return mapper(this.value);
  }
  orElse(other) {
    if (this.isPresent()) {
      return this.value;
    }
    return other;
  }
  orElseGet(other) {
    if (this.isPresent()) {
      return this.value;
    }
    return other();
  }
  orElseThrow(errorSupplier) {
    if (this.isPresent()) {
      return this.value;
    }
    throw errorSupplier();
  }
};
var Optional = OptionalValue.of;
Optional.empty = OptionalValue.empty;

// src/service-observer/index.ts
var ServiceObserver = class {
  constructor(listeners = {}) {
    this.listeners = listeners;
  }
  static bind(callback) {
    const serviceCallback = function(...args) {
      return callback(new ServiceObserver(), ...args);
    };
    serviceCallback.observe = function(listeners) {
      return (...args) => callback(new ServiceObserver(listeners), ...args);
    };
    return serviceCallback;
  }
  emit(type, value) {
    var _a, _b;
    (_b = (_a = this.listeners)[type]) == null ? void 0 : _b.call(_a, value);
    return this;
  }
};
export {
  BlurbBookSkuV1,
  BlurbSku,
  BlurbSkuBase,
  BlurbSkuV1,
  BlurbSkuV1Base,
  BlurbWallArtSkuV1,
  MailTo,
  Optional,
  OptionalValue,
  ServiceObserver,
  checkNumberInput,
  classNames,
  cls,
  defaultValue,
  delayedResponse,
  filterNullableArray,
  groupBy,
  inlineRetry,
  isArray,
  isArrayOfType,
  isCustomEvent,
  isEmptyString,
  isError,
  isFunction,
  isNull,
  isNumber,
  isObject,
  isString,
  isUndefined,
  objectEntries,
  objectKeys,
  objectsSum,
  optArray,
  optObj,
  propertyCombinations,
  randomDate,
  randomNumber,
  randomValue,
  retry,
  safelyParseJson,
  sleep,
  sumArray,
  validateObject
};
